import { createAsyncThunk } from "@reduxjs/toolkit";
import { send } from "../../app/appSlice";
import { AppThunkApi } from "../../app/store";
import * as service from "../../services/supervisor";

export const getSupervisorList = createAsyncThunk<any[], void, AppThunkApi>(
  "supervisor/getSupervisorList",
  async (_, api) => {
    return send(service.getSupervisorList(), api);
  }
);
